<section>
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div class="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div class="flex justify-between items-center p-4 border-b">
                <h6 class="text-lg font-semibold">Service Cancellation</h6>
                <button type="button" class="text-gray-500 hover:text-gray-700" (click)="close()">
                    <span class="text-2xl">&times;</span>
                </button>
            </div>
            <div class="p-6">
                <div class="flex justify-center">
                    <span class="text-yellow-500 font-medium">Are you sure you want to cancel this service item?</span>
                </div>
            </div>
            <div class="flex justify-between p-4 border-t">
                <button type="button" 
                        class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                        (click)="cancelServiceItem()">
                    Yes
                </button>
                <button type="button" 
                        class="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
                        (click)="close()">
                    No
                </button>
            </div>
        </div>
    </div>
</section>